import { render, staticRenderFns } from "./PersonalInfoProtectionNotice.vue?vue&type=template&id=19a8d16c&scoped=true"
import script from "./PersonalInfoProtectionNotice.vue?vue&type=script&lang=js"
export * from "./PersonalInfoProtectionNotice.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfoProtectionNotice.vue?vue&type=style&index=0&id=19a8d16c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a8d16c",
  null
  
)

export default component.exports